import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=b941ff70&scoped=true"
import script from "./ProjectMembers.vue?vue&type=script&lang=js"
export * from "./ProjectMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=b941ff70&prod&scoped=true&lang=scss"
import style1 from "./ProjectMembers.vue?vue&type=style&index=1&id=b941ff70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b941ff70",
  null
  
)

export default component.exports